<div class="confirm-dialog">
  <h3 [innerHTML]="text"></h3>
  <p [innerHTML]="body"></p>

  <app-datepicker
    label="Data rozpoczęcia ochrony"
    placeholder="2000-01-01 00:00"
    [required]="true"
    [minDate]="minDate"
    [control]="periodStartControl"
  ></app-datepicker>
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button (click)="confirm()" [disabled]="periodStartControl.invalid" mat-raised-button color="warn"><span> Wystaw polisę</span></button>
    </div>
    <div>
      <button (click)="decline()" mat-raised-button color="primary" class="confirm-dialog-decline-button"><span> anuluj</span></button>
    </div>
  </div>
</div>
